/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"
import { GoogleMapInfoWindow } from "@shared-components/GoogleMap/GoogleMapInfoWindow"
import {
  GoogleMapMarker,
  GoogleMapMarkerProps,
} from "@shared-components/GoogleMap/GoogleMapMarker"
import { forceCheck } from "react-lazyload"

export type GoogleMapMarkerWithInfoWindowProps = GoogleMapMarkerProps

const GoogleMapMarkerWithInfoWindow: React.FC<
  GoogleMapMarkerWithInfoWindowProps
> = ({ children, isOpen, onOpenFnc, ...props }) => {
  return (
    <GoogleMapMarker
      {...props}
      isOpen={isOpen}
      onClick={e => {
        e.domEvent.stopPropagation()
        onOpenFnc("")
      }}
    >
      {isOpen && (
        <GoogleMapInfoWindow
          onLoad={() => setTimeout(() => forceCheck(), 300)} // Make sure we load any lazy loaded image
          // onCloseClick={() => setInfoWindowOpen(false)}
        >
          {children}
        </GoogleMapInfoWindow>
      )}
    </GoogleMapMarker>
  )
}

GoogleMapMarkerWithInfoWindow.defaultProps = {}

export { GoogleMapMarkerWithInfoWindow }
